import React, { useEffect, useRef, useState } from "react";
import {
  FaChevronDown,
  FaSignOutAlt,
  FaUserCircle,
  FaUserFriends,
  FaTag,
} from "react-icons/fa";

const getUserName = (user) => {
  if (!user) return "Utilisateur";

  const firstName = user.prenom || user.first_name || user.firstname || "";
  const lastName = user.nom || user.last_name || user.lastname || "";

  return (
    `${firstName} ${lastName}`.trim() ||
    user.username ||
    user.email ||
    "Utilisateur"
  );
};

const getRoleLabel = (user) => {
  const roleId = Number(user?.role_id);

  if (roleId === 1) return "Administrateur";
  if (roleId === 3) return "Judoka(te)";
  if ([5, 6, 7].includes(roleId)) return "Coach";
  return "Judoka";
};

const Navbar4UserMenu = ({ user, onNavigate, onLogout }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const userName = getUserName(user);
  const roleLabel = getRoleLabel(user);
  const avatar =
    user?.photoURL || user?.photo_url || user?.avatar || "/img/user_avatar.jpg";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  if (!user) return null;

  const handleNavigate = (path) => {
    onNavigate(path);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex min-h-[52px] items-center gap-3 rounded-2xl border border-slate-200 bg-white py-2 pl-2 pr-3 text-slate-800 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-white/10 dark:bg-white/[0.07] dark:text-white"
        aria-label="Menu utilisateur"
      >
        <img
          src={avatar}
          alt={userName}
          className="h-9 w-9 rounded-xl object-cover ring-1 ring-slate-200 dark:ring-white/10"
        />

        <span className="hidden min-w-0 flex-1 text-left md:flex md:flex-col md:justify-center">
          <span className="truncate text-[13px] font-bold leading-tight text-slate-900 dark:text-white">
            {userName}
          </span>
          <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400 dark:text-white/45">
            {roleLabel}
          </span>
        </span>

        <FaChevronDown
          className={`shrink-0 text-[10px] text-slate-400 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div className="absolute right-0 z-[90] mt-3 w-[290px] overflow-hidden rounded-[1.6rem] border border-slate-200 bg-white shadow-2xl dark:border-white/10 dark:bg-slate-950">
          <div className="bg-slate-50 p-4 dark:bg-white/[0.04]">
            <div className="flex items-center gap-3">
              <img
                src={avatar}
                alt={userName}
                className="h-12 w-12 rounded-2xl object-cover ring-2 ring-white dark:ring-white/10"
              />

              <div className="min-w-0">
                <p className="truncate font-heading text-sm font-bold text-slate-950 dark:text-white">
                  {userName}
                </p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400 dark:text-white/45">
                  {roleLabel}
                </p>
              </div>
            </div>
          </div>

          <div className="p-2">
            <button
              type="button"
              onClick={() => handleNavigate("/profile-utilisateur")}
              className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 dark:text-white dark:hover:bg-white/[0.07]"
            >
              <FaUserCircle className="text-sky-600" />
              Profil utilisateur
            </button>

            <button
              type="button"
              onClick={() => handleNavigate("/profile-judoka")}
              className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 dark:text-white dark:hover:bg-white/[0.07]"
            >
              <FaUserFriends className="text-orange-500" />
              Profil judoka
            </button>

            <button
              type="button"
              onClick={() => handleNavigate("/formules-tarifs")}
              className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 dark:text-white dark:hover:bg-white/[0.07]"
            >
              <FaTag className="text-amber-500" />
              Formules & tarifs
            </button>

            <div className="my-2 h-px bg-slate-200 dark:bg-white/10" />

            <button
              type="button"
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
              className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-sm font-bold text-red-600 transition hover:bg-red-50 dark:hover:bg-red-500/10"
            >
              <FaSignOutAlt />
              Déconnexion
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar4UserMenu;